"use strict";
import { setupi18n } from "i18n/i18n-setup-interface";
import "@reach/dialog/styles.css";
import "global.css";
import "polyfills";
import "tracing";
setupi18n();
